export class aboutFullData {
  title: string = "";
  text: string = "";
  imgUrl: string = ""
}
